exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AppButton_component_ZirA {\n  display: inline-block;\n\n  width: 125px;\n  height: 37px;\n\n  background-size: 100% 100%;\n}\n\n.AppButton_googlePlay_tMS- {\n  background-image: url(https://static.beeline.ru/upload/images/mlk/images/googlePlay.png);\n}\n\n.AppButton_appStore_21nk {\n  background-image: url(https://static.beeline.ru/upload/images/mlk/images/appStore.png);\n}\n", ""]);

// exports
exports.locals = {
	"component": "AppButton_component_ZirA",
	"googlePlay": "AppButton_googlePlay_tMS-",
	"appStore": "AppButton_appStore_21nk"
};